import React from "react";
import { X } from "lucide-react";
import "./UserViewModal.css";
import formatPhone from "../../../utils/formatPhone";

interface User {
  id: number;
  name: string;
  userType: "Administrador" | "Usuário Comum" | "Selecionador" | "Colaborador";
  avatar: string;
  fullName?: string;
  phone?: string;
  whatsapp?: string;
  email?: string;
  institution?: string;
  course?: string;
  degree?: string;
  curriculumLink?: string;
}

interface UserViewModalProps {
  user: User | null;
  isOpen: boolean;
  onClose: () => void;
  onDelete: (userId: number) => void;
}

const UserViewModal: React.FC<UserViewModalProps> = ({
  user,
  isOpen,
  onClose,
  onDelete,
}) => {
  if (!isOpen || !user) return null;

  const handleDeleteClick = () => {
    onDelete(user.id);
    onClose();
  };

  const getUserTypeClass = (userType: User["userType"]) => {
    const typeMap = {
      Administrador: "badge-admin",
      "Usuário Comum": "badge-user",
      Selecionador: "badge-selector",
      Colaborador: "badge-collaborator",
    };
    return typeMap[userType];
  };

  return (
    <div
      className="modal show d-block user-view-modal"
      style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
      tabIndex={-1}
    >
      <div className="modal-dialog modal-lg modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Contas de usuário - Visualizar</h5>
            <button type="button" className="btn-close" onClick={onClose}>
              <X size={20} />
            </button>
          </div>
          <div className="modal-body">
            <div className="user-view-container">
              {/* <div className="user-sidebar">
                <div className="user-profile">
                  <img 
                    src={user.avatar} 
                    alt={user.name} 
                    className="user-profile-avatar" 
                  />
                  <h6 className="user-profile-name">{user.name}</h6>
                </div>
                <div className="user-menu">
                  <div className="menu-item active">Perfil</div>
                  <div className="menu-item">Colaborar com imagens</div>
                  <div className="menu-item">Outras informações</div>
                  <div className="menu-item">Alterar senha</div>
                  <div className="menu-item">Solicitações de colaboração</div>
                  <div className="menu-item highlighted">Contas de usuários</div>
                  <div className="menu-item">Relatórios</div>
                </div>
              </div> */}

              <div className="user-content">
                {/* <div className="breadcrumb">
                  <span className="breadcrumb-link">👥 Usuários</span>
                </div> */}

                <div className="user-type-section">
                  <span className="user-type-label">Tipo de perfil:</span>
                  <span
                    className={`user-type-badge ${getUserTypeClass(
                      user.userType
                    )}`}
                  >
                    {user.userType}
                  </span>
                </div>

                <div className="user-info-sections">
                  <div className="info-section">
                    <h6 className="section-title">Informações pessoais</h6>
                    <div className="info-grid">
                      <div className="info-item">
                        <label>Nome completo:</label>
                        <span>{user.fullName || user.name || "—"}</span>
                      </div>
                      <div className="info-item">
                        <label>Telefone:</label>
                        <span>
                          {user.phone ? formatPhone(String(user.phone)) : "—"}
                        </span>
                      </div>
                      <div className="info-item">
                        <label>Whatsapp:</label>
                        <span>
                          {user.whatsapp
                            ? formatPhone(String(user.whatsapp))
                            : "—"}
                        </span>
                      </div>
                      <div className="info-item full-width">
                        <label>E-mail:</label>
                        <span>{user.email || "—"}</span>
                      </div>
                    </div>
                  </div>

                  <div className="info-section">
                    <h6 className="section-title">Informações profissionais</h6>
                    <div className="info-grid">
                      <div className="info-item full-width">
                        <label>Instituição:</label>
                        <span>{user.institution || "—"}</span>
                      </div>
                      <div className="info-item full-width">
                        <label>Curso ou Área de Formação:</label>
                        <span>{user.course || "—"}</span>
                      </div>
                      <div className="info-item full-width">
                        <label>Curso ou Área de Formação:</label>
                        <span>{user.degree || "—"}</span>
                      </div>
                      <div className="info-item full-width">
                        <label>Link do currículo lattes:</label>
                        <span className="link-text">
                          {user.curriculumLink || "—"}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-secondary"
              onClick={onClose}
            >
              Voltar
            </button>
            <button
              type="button"
              className="btn btn-danger text-white"
              onClick={handleDeleteClick}
            >
              Excluir
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UserViewModal;
